module.exports = __webpack_public_path__ + "img/surgeries.833c806a.png";